import React from 'react';
import {useFormikContext} from 'formik';
import {TextField} from '@mui/material';
import Card from '@mui/material/Card';
import {Grid} from '@mui/material';

export default function ConservationEntryTwo() {
  const {values} = useFormikContext();
  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 12}}>
        <Grid container spacing={1.5}>
          {values?.dimensions?.map((dimension, dimIndex) => {
            return dimension?.items?.map((item, itemIndex) => (
              <Grid item sm={6} xs={12} key={`${dimIndex}-${itemIndex}`}>
                <TextField variant={'outlined'} size={'small'} fullWidth label={item?.label}
                       value={`${item?.value || ''} ${item?.unit || ''}`} disabled
                       InputLabelProps={{
                         style: {fontSize: 14, color: '#929191'},
                         shrink: true,
                         marginDense: false
                       }}/>
              </Grid>
            ))
          })}
        </Grid>
        <TextField variant={'outlined'} size={'small'} fullWidth label={'Description'}
               value={values?.description || ''} disabled multiline minRows={3} maxRows={3}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
      </Card>
    </div>
  );
}